import { useTranslation } from 'react-i18next';

import "./Entry.scss";
import bimLogo from "static/images/bim_logo.svg";

const EntryWrap = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className="entry">
      <div className="entry-container">
        <div className="entry-left">
          {children}
        </div>

        <div className="entry-right">
          <div className="logo">
            <img
              src={bimLogo}
              alt="Logotype"
            />
          </div>
          <h1>
            {t('nearly_there')}
          </h1>

          <p>
            {t('one_more_step')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EntryWrap;
